module.exports = __webpack_public_path__ + "img/Eelarvetäitmine-teal.2ea76527.jpg";